import Banner from '../../sections/common/banner';

import { data } from '../../../globals/data/arts';

import SectionServices3 from '../../sections/home/index3/section-services3';
import SectionWhatWeDo2 from '../../sections/home/index3/section-what-we-do2';
import SectionWhyChooseUs3 from '../../sections/home/index3/section-why-choose-us3';
import SectionBlogs2 from '../../sections/home/index2/section-blogs2';
import ServicesPageHelmet from '../../helmets/ServicesPageHelmet';

export default function ArtPage() {
  return (
    <>
      <ServicesPageHelmet />

      <Banner _data={data.banner} />
      <SectionWhyChooseUs3 _data={data.whychoosus} />
      <SectionWhatWeDo2 _data={data.whatwedo} />
      <SectionBlogs2 _data={data.blogs} />
    </>
  );
}
